'use client'

// MUI Imports
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'

// Third-party Imports
import { Icon } from '@iconify/react'

// Component Imports
import CustomAvatar from '../../../../../components/common/Template_Layouts/@core/components/mui/Avatar'

const CreditNoteCard = ({ stats, onStatusClick }) => {
    const data = [
        {
            title: stats?.total || 0,
            subtitle: 'Total Credit Notes',
            icon: 'ri:file-list-3-line',
            color: 'primary',
            key: 'All'
        },
        {
            title: stats?.open || 0,
            subtitle: 'Open',
            icon: 'ri:time-line',
            color: 'warning',
            key: 'Open'
        },
        {
            title: stats?.sentForApproval || 0,
            subtitle: 'Sent For Approval',
            icon: 'ri:send-plane-line',
            color: 'info',
            key: 'Sent For Approval'
        },
        {
            title: stats?.cancelled || 0,
            subtitle: 'Cancelled',
            icon: 'ri:close-circle-line',
            color: 'error',
            key: 'Cancelled'
        }
    ]

    return (
        <Card sx={{ width: '100%' }}>
            <CardContent sx={{ p: '16px !important' }}>
                <div style={{ display: 'flex', width: '100%' }}>
                    {data.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => onStatusClick && onStatusClick(item.key)}
                            style={{
                                flex: 1,
                                cursor: 'pointer',
                                borderRight: index < data.length - 1 ? '1px solid #e0e0e0' : 'none',
                                padding: '8px 16px',
                                transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={e => e.currentTarget.style.opacity = '0.8'}
                            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                        >
                            <div className='flex justify-between items-center'>
                                <div className='flex flex-col'>
                                    <Typography variant='h4'>{item.title}</Typography>
                                    <Typography color="textSecondary">{item.subtitle}</Typography>
                                </div>
                                <CustomAvatar variant='rounded' size={42} skin='light' color={item.color}>
                                    <Icon icon={item.icon} fontSize={26} />
                                </CustomAvatar>
                            </div>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    )
}

export default CreditNoteCard
